import { Navigation, Phone } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useSite } from "@/context/SiteContext";
import { directionsUrl } from "@/lib/api";

function LocationAction({ loc }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-white/80" data-testid={`mobile-bar-${loc.id}-btn`}>
          <Phone className="h-4 w-4 text-[var(--gold)]" />
          <span className="font-display text-xs font-bold uppercase tracking-wider">{loc.name}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" className="w-56 border-white/10 bg-[#141414] p-2">
        <a href={`tel:${loc.phone_tel}`} className="flex items-center gap-3 rounded-sm px-3 py-3 text-sm text-white hover:bg-white/5" data-testid={`mobile-bar-call-${loc.id}`}>
          <Phone className="h-4 w-4 text-[var(--gold)]" /> Call {loc.name}
        </a>
        <a href={directionsUrl(loc)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 rounded-sm px-3 py-3 text-sm text-white hover:bg-white/5" data-testid={`mobile-bar-directions-${loc.id}`}>
          <Navigation className="h-4 w-4 text-[var(--gold)]" /> Directions
        </a>
      </PopoverContent>
    </Popover>
  );
}

export function MobileActionBar() {
  const { content, openJoin } = useSite();
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 flex items-stretch border-t border-white/10 bg-black/90 backdrop-blur-xl md:hidden" data-testid="mobile-action-bar">
      {content.locations.map((loc) => <LocationAction key={loc.id} loc={loc} />)}
      <button onClick={() => openJoin()} className="m-2 flex-[1.3] rounded-sm bg-[var(--gold)] font-display text-lg font-black uppercase tracking-wide text-black" data-testid="mobile-bar-join-btn">
        Join Now
      </button>
    </div>
  );
}
